import Projectile from './Projectile.js';

export class ProjectilePool {
    constructor(scene = null) {
        this.projectiles = [];
        this.maxDistance = 500; // Reduced max distance for quicker cleanup
        this.scene = scene;
        this.debug = false;

        // For sharing with the global scope
        window.projectilePool = this;

        // Preload 50 projectiles instead of 100 for better performance
        for (let i = 0; i < 50; i++) {
            const projectile = new Projectile();
            projectile.isActive = false; 
            this.projectiles.push(projectile);

            // Store a reference to the scene on the projectile
            projectile.scene = this.scene;
            
            // Note: Projectiles now manage their own scene addition
        }
        
        console.log(`[ProjectilePool] Initialized with ${this.projectiles.length} projectiles`);
    }

    getAvailableProjectile() {
        // First try to find an inactive projectile
        const inactiveProjectile = this.projectiles.find(projectile => !projectile.isActive);
        
        if (inactiveProjectile) {
            if (this.debug) console.log("[ProjectilePool] Reusing inactive projectile");
            return inactiveProjectile;
        }
        
        // If all are active, create a new one
        if (this.debug) console.log("[ProjectilePool] Creating new projectile (all are active)");
        const newProjectile = new Projectile();
        newProjectile.scene = this.scene;
        this.projectiles.push(newProjectile);
        
        return newProjectile;
    }

    updateAll(deltaTime) {
        let activeCount = 0;
        
        for (const projectile of this.projectiles) {
            try {
                if (projectile?.isActive) {
                    projectile.update(deltaTime);
                    activeCount++;

                    // Deactivate if it goes too far or mesh/position becomes invalid
                    if (!projectile.mesh.position || 
                        projectile.mesh.position.length() > this.maxDistance) {
                        projectile.deactivate();
                    }
                }
            } catch (error) {
                console.error('Error updating projectile:', error);
                projectile?.deactivate?.();
            }
        }
        
        // Debug output for active projectiles
        if (this.debug && activeCount > 0) {
            console.log(`[ProjectilePool] ${activeCount} active projectiles`);
        }
    }
    
    // Add a method to reset all projectiles (useful when changing scenes)
    resetAll() {
        for (const projectile of this.projectiles) {
            projectile.deactivate();
        }
        console.log("[ProjectilePool] All projectiles reset");
    }
}
